"use strict";
exports.__esModule = true;
var types_1 = require("../../types");
/**
 * @method createGetNodeInfo
 *
 * @param {Provider} provider - Network provider
 *
 * @memberof module:core
 *
 * @return {function} {@link #module_core.getNodeInfo `getNodeInfo`}
 */
exports.createGetNodeInfo = function (_a) {
    var send = _a.send;
    /**
     * Returns information about connected node by calling
     * [`getNodeInfo`](https://docs.iota.works/iri/api#endpoints/getNodeInfo) command.
     *
     * @example
     *
     * ```js
     * getNodeInfo()
     *   .then(info => console.log(info))
     *   .catch(err => {
     *     // ...
     *   })
     * ```
     *
     * @method getNodeInfo
     *
     * @memberof module:core
     *
     * @param {Callback} [callback] - Optional callback
     *
     * @return {Promise}
     * @fulfil {NodeInfo} Object with information about connected node.
     * @reject {Error}
     * - Fetch error
     */
    return function getNodeInfo(callback) {
        return send({
            command: types_1.IRICommand.GET_NODE_INFO
        }).asCallback(callback);
    };
};
//# sourceMappingURL=createGetNodeInfo.js.map